import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { FilledButton } from 'shared-components/Buttons';
import { ReactComponent as EmptyFilesIcon } from 'images/dashboard/empty-files.svg';
import { EmptyContainerWrapper, Title, Description } from './styles';

export const EmptyContainer = ({
  title,
  description,
  ctaText,
  renderCta,
  inline,
  hideCta = false,
}) => (
  <EmptyContainerWrapper>
    <Box
      {...(inline && {
        display        : 'flex',
        flexDirection  : 'row',
        justifyContent : 'center',
        mb             : 4,
      })}>
      <EmptyFilesIcon />
      <Stack
        justifyContent='center'
        {...(inline && { alignItems: 'start', ml: 2 })}>
        <Title>
          <Typography
            variant='pl3'>{title}</Typography>
        </Title>
        {description && (
          <Description
            inline={inline}>
            <Typography
              variant='pl3'>{description}</Typography>
          </Description>
        )}
      </Stack>
    </Box>
    {!hideCta &&
      (renderCta
        ? renderCta
        : ctaText && (
          <FilledButton
            fullWidth
            background='#00778B'
            height='44px'
            fontFamily='Montserrat'>
            {ctaText}
          </FilledButton>
        ))}
  </EmptyContainerWrapper>
);
